var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticStyle:{"width":"25rem"}},[_c('img',{staticClass:"img-icon px-2",attrs:{"src":_vm.imgicon}}),_c('h3',{staticClass:"header-name"},[_vm._v(" "+_vm._s(_vm.headername)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }